import { createReducer } from '../common';
import { SET_CARD_NAME, SET_CARD_NUMBER, SET_LAST_FOUR, SET_CARD_BRAND, SET_CARD_DATE, SET_CARD_CVV, SET_CARD_ZIP, SET_CARD_ERR, SET_CARD_VALIDITY, VALIDATE_CARD } from 'actions/card';

const onlyNum = RegExp('^[0-9]+$');

const formatCardNumber = (oldValue, cardNumber) => {
    const cardLength = cardNumber.length;
    const oldValueLength = oldValue.length;

    if (oldValueLength > cardLength) {
        return cardNumber;
    }

    let part1 = '', part2 = '';

    if (cardLength === 4) {
        part1 = cardNumber.slice(0, 4);
        part2 = cardNumber.slice(4);
        cardNumber = part1 + ' ' + part2;
    }

    if (cardLength === 9) {
        part1 = cardNumber.slice(0, 9);
        part2 = cardNumber.slice(9);
        cardNumber = part1 + ' ' + part2;
    }

    if (cardLength === 14) {
        part1 = cardNumber.slice(0, 14);
        part2 = cardNumber.slice(14);
        cardNumber = part1 + ' ' + part2;
    }

    if (cardLength === 19) {
        part1 = cardNumber.slice(0, 19);
        part2 = cardNumber.slice(19);
        cardNumber = part1 + ' ' + part2;
    }

    return cardNumber;

};

const formatExpirationDate = (date, value) => {
    let expirationDate = value;
    const lastNum = value.length;
    const lastSymbol = value[lastNum - 1];
    const addSymbol = date.length < lastNum;

    if (value && !onlyNum.test(lastSymbol) && lastSymbol !== '/') {
        return date;
    }

    if (addSymbol) {
        if (lastNum === 2) {
            expirationDate = expirationDate + '/';
        }
        if (date.length === 2) {
            expirationDate = date + '/' + lastSymbol;
        }
        return expirationDate;
    }

    expirationDate = expirationDate.slice(0, lastNum);
    return expirationDate;
};

const formatCvv = (cvv, value) => {
    const changeCvv = value.length;
    const lastSymbol = value[changeCvv - 1];
    const addSymbol = cvv.length < changeCvv;

    if (value && !onlyNum.test(lastSymbol) && lastSymbol !== '*') {
        return '';
    }

    if (addSymbol) {
        const newCvv = cvv + lastSymbol;
        return newCvv;
    }

    const newCvv = cvv.slice(0, changeCvv);
    return newCvv;
};

const initState = {
    name: '',
    number: '',
    date: '',
    cvv: '',
    zip: '',
    lastFour: '',
    cardBrand: '',
    err: [],
    isCreditCardValid: false,
    validateCard: false,
};

const setCardName = (state, { payload }) => {
    return {
        ...state,
        name: payload
    };
};

const setCardNumber = (state, { payload }) => {
    const testNun = payload.replace(/\s/g, '');
    if (payload && !onlyNum.test(testNun)) {
        return state;
    }
    const number = formatCardNumber(state.number, payload);
    return {
        ...state,
        number,
    };
};

const setCarDate = (state, { payload }) => {
    const date = formatExpirationDate(state.date, payload);
    return {
        ...state,
        date,
    };
};

const setCardCVV = (state, { payload }) => {
    const cvv = formatCvv(state.cvv, payload);

    if (!cvv) {
        return {
            ...state,
            cvv: ''
        };
    }
    return {
        ...state,
        cvv,
    };
};

const setCardZip = (state, { payload }) => {
    return {
        ...state,
        zip: payload
    };
};

const setCardErr = (state, { payload }) => {
    return {
        ...state,
        err: payload
    };
};

const setCardValidity = (state, { payload }) => {
    return {
        ...state,
        isCreditCardValid: payload,
        ...payload
    };
};

const setLastFour = (state, { payload }) => {
    return {
        ...state,
        lastFour: payload
    };
};

const cardBrand = (state, { payload }) => {
    return {
        ...state,
        cardBrand: payload
    };
};

const validateCard = (state, { payload }) => {
    return {
        ...state,
        validateCard: payload,
        ...payload,
    };
};


const handlers = {
    [SET_CARD_NAME]: setCardName,
    [SET_CARD_NUMBER]: setCardNumber,
    [SET_CARD_DATE]: setCarDate,
    [SET_CARD_CVV]: setCardCVV,
    [SET_CARD_ZIP]: setCardZip,
    [SET_CARD_ERR]: setCardErr,
    [SET_CARD_VALIDITY]: setCardValidity,
    [SET_LAST_FOUR]: setLastFour,
    [SET_CARD_BRAND]: cardBrand,
    [VALIDATE_CARD]: validateCard,
};

export default createReducer(initState, handlers);
